<template>
  <form v-if="ready" @submit.prevent="submit">
    <div class="bg-light d-flex p-4 mb-4">
      <div>
        <base-checkbox v-model="payload.published">
          Published
        </base-checkbox>
      </div>
      <div class="mx-3">
        <base-checkbox v-model="payload.approved">
          Approved by Compliance
        </base-checkbox>
      </div>
    </div>
    <base-card>
      <template v-slot:header>
        <base-card-heading>Details</base-card-heading>
      </template>
      <div class="row">
        <div class="col-sm-6">
          <base-field label="Title">
            <base-input v-model="payload.title" placeholder="title" required />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Investment Type">
            <base-select v-model="payload.investmentType" placeholder="investment type" source="investmentTypes" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Project Type">
            <base-select v-model="payload.projectType" placeholder="project type" source="projectTypes" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Payment Schedule">
            <base-select v-model="payload.paymentSchedule" placeholder="payment schedule" source="paymentSchedule" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-left-icon="calendar-alt" label="Start Date">
            <base-input v-model="payload.startDate" datepicker placeholder="start date" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-left-icon="calendar-alt" label="End Date">
            <base-input v-model="payload.endDate" datepicker placeholder="end date" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-left-icon="calendar-alt" label="Repayment Date">
            <base-input v-model="payload.repaymentDate" datepicker placeholder="repayment date" />
          </base-field>
        </div>
        <div class="col-sm-12">
          <base-field label="Introduction">
            <wysiwyg-editor v-model="payload.intro" placeholder="introduction" />
          </base-field>
        </div>
        <div class="col-sm-12">
          <base-field label="Project Overview">
            <wysiwyg-editor v-model="payload.projectOverview" placeholder="project overview" />
          </base-field>
        </div>
        <div class="col-sm-12">
          <base-field label="Exit Strategy">
            <wysiwyg-editor v-model="payload.exitStrategy" placeholder="exit stratgey" />
          </base-field>
        </div>
        <div class="col-sm-12">
          <base-field label="Security Description">
            <wysiwyg-editor v-model="payload.securityDescription" placeholder="security description" />
          </base-field>
        </div>
      </div>
    </base-card>
    <base-card>
      <template v-slot:header>
        <base-card-heading>Address</base-card-heading>
      </template>
      <div class="row">
        <div class="col-sm-6">
          <base-field label="Address Line 1">
            <base-input v-model="payload.address.addressLine1" placeholder="address line 1" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Address Line 2">
            <base-input v-model="payload.address.addressLine2" placeholder="address line 2" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Town/City">
            <base-input v-model="payload.address.town" placeholder="town" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="County">
            <base-input v-model="payload.address.county" placeholder="county" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Postcode">
            <base-input v-model="payload.address.postcode" placeholder="postcode" />
          </base-field>
        </div>
      </div>
    </base-card>
    <base-card>
      <template v-slot:header>
        <base-card-heading>Valuation</base-card-heading>
      </template>
      <div class="row">
        <div class="col-sm-6">
          <base-field label="Valuer">
            <base-input v-model="payload.valuation.valuer" placeholder="valuer" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-left-icon="pound-sign" label="Amount">
            <base-input v-model="payload.valuation.amount" numeric placeholder="amount" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-left-icon="calendar-alt" label="Valuation Date">
            <base-input v-model="payload.valuation.date" datepicker placeholder="date" />
          </base-field>
        </div>
      </div>
    </base-card>
    <base-card>
      <template v-slot:header>
        <base-card-heading>Financials</base-card-heading>
      </template>
      <div class="row">
        <div class="col-sm-6">
          <base-field addon-left-icon="pound-sign" label="Cost per Share">
            <base-input v-model="payload.costPerShare" numeric placeholder="amount" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-right-icon="percent" label="Default Interest Rate">
            <base-input v-model="payload.defaultInterestRate" numeric placeholder="default interest rate" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-right-icon="percent" label="Loan to Value">
            <base-input v-model="payload.ltv" numeric placeholder="loan to value" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Security Type">
            <base-select v-model="payload.securityType" placeholder="security type" source="investmentSecurityTypes" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-left-icon="pound-sign" label="Security Value">
            <base-input v-model="payload.securityValue" numeric placeholder="security value" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-left-icon="pound-sign" label="Total Loan">
            <base-input v-model="payload.totalLoan" numeric placeholder="total loan" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-right="months" label="Loan Term">
            <base-input v-model="payload.loanTerm" numeric placeholder="months" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-left-icon="calendar-alt" label="Loan Start Date">
            <base-input v-model="payload.loanStartedAt" datepicker placeholder="date" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-right-icon="percent" label="Dividend">
            <base-input v-model="payload.dividend" numeric placeholder="dividend" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field addon-left-icon="pound-sign" label="Minimum Investment">
            <base-input v-model="payload.minimumInvestment" numeric placeholder="minimum investment" />
          </base-field>
        </div>
        <div class="col-sm-6">
          <base-field label="Share Type">
            <base-select v-model="payload.shareType" source="shareTypes" />
          </base-field>
        </div>
      </div>
    </base-card>
    <div class="text-right">
      <base-button icon-right="arrow-right" :loading="saving" primary submit>
        Save
      </base-button>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import WysiwygEditor from './WysiwygEditor.vue'

export default {
  name: 'InvestmentEditor',

  components: {
    WysiwygEditor
  },

  data: () => ({
    payload: {},
    ready: false,
    saving: false
  }),

  async created () {
    this.payload = this.$_.cloneDeep(this.investment)
    this.ready = true
  },

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity
    })
  },

  methods: {
    submit () {
      this.saving = true

      this.updateInvestment(this.payload)
        .then(() => {
          this.$emit('refresh')
          this.$flash.success('Investment successfully updated.')
        })
        .catch(err => this.$flash.failure(err))
        .finally(() => {
          this.saving = false
        })
    },

    ...mapActions({
      updateInvestment: 'core/investments/update'
    })
  }
}
</script>
